<template>
  <div>

    <b-row>
      <b-col lg="12">
        <div class="w-100 p-4 align-items-center justify-content-center">
          <b-row>
            <b-col
              cols="6"
              class="mb-2"
            >
              <div style="width: 160px; height: 160px; margin-left: 40px;">
                <VueSvgGauge
                  :start-angle="0"
                  :end-angle="240"
                  :separator-step="0"
                  :inner-radius="70"
                  :min="0"
                  :max="100"
                  :gauge-color="[{ offset: 30, color: '#22634d'}, { offset: 90, color: '#53FBC3'}]"
                  :scale-interval="0"
                  needleshape
                  :decimals="2"
                >
                  <div>
                    <div
                      align="center"
                      class="inner-text-1"
                      style="color: #53FBC3;"
                    >
                      <span
                        style="font-size: 38px; font-weight: 400;"
                      > {{ total }}</span>
                    </div>
                  </div>
                </VueSvgGauge>
                <!-- <div align="center">
                  <span>ความเร็ว 91 - 120 km/hr</span>
                </div> -->
                <div
                  align="right"
                  class="inner-text"
                  style="color: #53FBC3;  white-space: nowrap; margin-left: -40px;"
                >
                  <span style="font-size: 18px;">{{ incident_type }}</span>
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              class="mb-2"
            >
              <div style="width: 160px; height: 160px; margin-left: 60px;">
                <VueSvgGauge
                  :start-angle="0"
                  :end-angle="240"
                  :separator-step="0"
                  :inner-radius="70"
                  :min="0"
                  :max="100"
                  :gauge-color="[{ offset: 30, color: '#163a4e'}, { offset: 90, color: '#43BAFE'}]"
                  :scale-interval="0"
                  needleshape
                  :decimals="2"
                >
                  <div>
                    <div
                      align="center"
                      class="inner-text-1"
                      style="color: #43BAFE;"
                    >
                      <span
                        style="font-size: 38px; font-weight: 400;"
                      >{{ max_total }}</span>
                    </div>
                  </div>
                </VueSvgGauge>
                <div
                  align="right"
                  class="inner-text"
                  style="color: #43BAFE;  white-space: nowrap; margin-left: -40px;"
                >
                  <span style="font-size: 18px;">เหตุการณ์</span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BRow, BCol,
  // BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import axios from '@axios'
import { VueSvgGauge } from 'vue-svg-gauge'

export default {
  components: {
    BRow,
    BCol,
    VueSvgGauge,
    // BFormRadioGroup,
    // BFormRadio,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      sta: '',
      sumCountIn: '',
      sumCountOut: '',

      incident_type: 'เหตุการณ์',
      total: 'ไม่มี',
      max_total: 0,

      itemsStatistics: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    this.getFormula()
    this.interval = setInterval(() => {
      this.getFormula()
    }, 300000)
  },
  methods: {
    getFormula() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getTotal-Incident-G', { wid: this.$route.query.wid })
          .then(response => {
          // eslint-disable-next-line prefer-destructuring
            this.incident_type = response.data[0].incident_type
            this.max_total = response.data[0].max_total
            this.total = response.data[0].total
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getTotal-Incident', { wid: this.$route.query.wid })
          .then(response => {
          // eslint-disable-next-line prefer-destructuring
            this.incident_type = response.data[0].incident_type
            this.max_total = response.data[0].max_total
            this.total = response.data[0].total
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    toSafeString(number) {
      return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'
    },
    clearSelection() {
      this.sta = null
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
// @import '~vue2-datepicker/scss/index.scss';

.inner-text {
  // allow the text to take all the available space in the svg on top of the gauge
  height: 100%;
  width: 100%;
  margin-top: -80px;

  span {
    max-width: 100px;
    // ...
  }
}
.inner-text-1{
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

.checkbox-grid {
  display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 10px;
  }

  @media screen and (max-width: 600px) {
  .margintext0 {
    /* Move the text to the right when the screen is shrunk */
    margin-left: 30px;
    font-size: 28px;
  }
  .margintext200 {
    /* Move the text to the right when the screen is shrunk */
    margin-left: 170px;
    font-size: 28px;
  }
}

</style>
